<!-- 西医处方 -->
<template>
  <div class="diagnose-wrapper">
    <!-- 诊断信息 -->
    <div class="diagnose-section">
      <div class="diagnose-info-item">
        <div class="diagnose-title"><span class="required">就诊人</span></div>
        <div class="info-content">
          <div class="patient-info">{{patientInfo.username}} {{patientInfo.gender | genderFilter}} {{patientInfo.birthday | ageFilter}} {{(patientInfo.allergy == '否认') ? '无过敏史' : patientInfo.allergy == '不确定' ? '不确定过敏史' : patientInfo.allergy}}</div>
        </div>
      </div>
      <div class="diagnose-info-item">
        <div class="diagnose-title"><span class="required">主诉</span></div>
        <div class="info-content">
          <textarea class="info-textarea" v-model="condition" maxlength="100" placeholder="患者病情描述"></textarea>
          <span class="text-limit">{{condition.length}}/100</span>
        </div>
      </div>
      <div class="diagnose-info-item">
        <div class="diagnose-title"><span class="required">诊断</span></div>
        <div class="info-content">
          <textarea class="info-textarea" v-model="diagnoseText" maxlength="100" placeholder="诊断描述"></textarea>
          <span class="text-limit">{{diagnoseText.length}}/100</span>
        </div>
      </div>
    </div>
    <!-- 处方信息 -->
    <div class="diagnose-section">
      <div class="prescription-box">
        <div class="prescription-type">{{formulationType | formulationTypeFilter}}</div>
        <div class="prescription-header">
          <h4>R:</h4>
        </div>
        <div class="prescription-content">
          <div class="herb-item" v-for="item in herbList">
            <div class="herb-info">
              <div class="herb-name">{{formulationType == 3 ? `${item.name}` : `${item.common_name}`}} {{item.specification}}/{{item.unit}}</div>
              <div class="herb-num">x{{item.num}}</div>
            </div>
            <div class="herb-tip"><span>用法用量:</span>共{{item.days}}天，{{item.frequency}}，每次{{item.dosage}}{{item.dosage_unit}}，{{item.usage}}</div>
            <div class="herb-tip" v-if="item.remark"><span>特殊说明:</span>{{item.remark}}</div>
            <div class="herb-control">
              <button class="del-herb" @click="delHerb(item)">删除</button>
              <button class="edit-herb" @click="editHerb(item)">编辑药品</button>
            </div>
          </div>
        </div>
      </div>
      <div class="prescription-control">
        <button class="prescription-button" @click="getHistory">历史处方</button>
        <button class="prescription-button" @click="addHerb">添加药品</button>
      </div>
    </div>
    <!-- 注意事项 -->
    <div class="diagnose-section">
      <div class="dosage-item">
        <div class="diagnose-title"><span>注意事项</span></div>
        <div class="dosage-content">
          <div class="dosage-textarea">
            <textarea class="info-textarea" v-model="attentionText" v-ios-bug-fixed maxlength="100" placeholder="医嘱"></textarea>
            <span class="text-limit">{{attentionText.length}}/100</span>
          </div>
          <div class="puick-attention">
            <h4 class="attention-title">服药时间</h4>
            <div class="attention-list">
              <div class="attention-item" @click="puickFillAttention(item)" v-for="item in attentionTimeData">{{item}}</div>
            </div>

          </div>
          <div class="puick-attention">
            <h4 class="attention-title">忌口与禁忌</h4>
            <div class="attention-list">
              <div class="attention-item" @click="puickFillAttention(item)" v-for="item in attentionTabooData">{{item}}</div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- 超用量签章信息 -->
    <div class="diagnose-section" v-if="excessHerbs.length > 0">
      <div class="over-dose-box">
        <div class="excess-list">
          <div class="excess-item" v-for="item in excessHerbs">{{item.name}}<span v-if="item.isUnitExcess">超过单日最大剂量</span><span v-if="item.isExcess && item.isUnitExcess">及</span><span v-if="item.isExcess">用量超过{{item.maxDosage}}天</span></div>
        </div>
        <div class="over-tips">确认已知晓</div>
        <!-- <div class="over-tips">{{excessHerbs.join('、')}}用量超过7天，<span></span></div> -->
        <div class="sign-box">
          <div class="type">医生签章</div>
          <div class="signature">
            <span>{{userInfo.username}}</span>
            <p>{{patientInfo.doc_id}}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 价格信息 -->
    <div class="diagnose-section">
      <div class="price-item">
        <div class="price-type">药品费</div>
        <div class="normal-price" :class="{'grey': parseFloat(totalPrice) == 0}">¥ {{parseFloat(totalPrice).toFixed(2)}}</div>
      </div>
      <div class="total-price">
        <div class="total">共计</div>
        <div class="price" :class="{'grey': parseFloat(totalPrice) == 0}">¥ {{totalPrice | int}}<span>{{totalPrice | float}}</span></div>
      </div>
    </div>
    <div class="diagnose-bottom-control">
      <button class="botton-button send" @click="sendScriptTip">提交</button>
    </div>

    <!-- 发送给患者弹窗 -->
    <x-dialog v-if="sendScriptShow" title="发送处方" @close="sendScriptShow = false">
      <div class="dialog-content">
        <div class="text">是否将处方发送给患者</div>
        <div class="control">
          <button class="cancel" @click="sendScriptShow = false">再修改一下</button>
          <button class="confirm" @click="sendScript">确定</button>
        </div>
      </div>
    </x-dialog>

    <!-- 历史处方选择 -->
    <van-popup v-model="scriptPickShow" position="bottom" :style="{height: '100%'}">
      <div class="popup-wrapper">
        <div class="popup-header">
          历史处方
          <span class="close-popup" @click="scriptPickShow = false">取消</span>
        </div>
        <div class="data-wrapper script-wrapper">
          <!-- 历史处方列表 -->
          <div class="prescription-list">
            <template v-if="scriptList.length > 0">
              <div class="prescription-item" v-for="item in scriptList" :key="item.prescription_id" @click="chooseScript(item)">
                <div class="item-head">
                  <div class="item-title">{{item.create_time | dateFilter('day')}}</div>
                  <div class="sub-title">诊断: {{item.diagnose}}</div>
                </div>
                <div class="prescription-card-content">
                  <div class="history-herb-item" v-for="herb in item.content">
                    <div class="herb-info">
                      <div class="herb-name">{{formulationType == 3 ? `${herb.name}` : `${herb.common_name}`}} {{herb.specification}}/{{herb.unit}}</div>
                      <div class="herb-num">x{{herb.num}}</div>
                    </div>
                    <div class="herb-tip"><span>用法用量:</span>共{{herb.days}}天，{{herb.frequency}}，每次{{herb.dosage}}{{herb.dosage_unit}}，{{herb.usage}}</div>
                    <div class="herb-tip" v-if="herb.remark"><span>特殊说明:</span>{{herb.remark}}</div>
                  </div>
                </div>
              </div>
            </template>
            <div class="empty-data" v-else>
              <icon icon-class="empty-template"></icon>
              <p>暂无历史处方</p>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<style lang="less">
  .diagnose-wrapper{
    min-height: 100vh;
    background: #F7F7F7;
    width: 100%;
    padding: 12px 8px 0;
    .diagnose-section{
      margin-bottom: 12px;
      background: #FFF;
      border-radius: 6px;
      padding: 24px 16px 1px;
      .diagnose-title{
        font-size: 16px;
        line-height: 16px;
        color: #666;
        font-weight: bold;
        span{
          position: relative;
          &.required::after{
            content: '*';
            position: absolute;
            left: 100%;
            top: 0;
            font-size: 16px;
            line-height: 16px;
            color: @error;
            margin-left: 1px;
          }
        }
      }
      .info-textarea{
        width: 100%;
        height: 96px;
        background: #F7F7F7;
        border-radius: 4px;
        padding: 12px;
        font-size: 14px;
        line-height: 20px;
        color: @black;
        resize: none;
      }
      .text-limit{
        position: absolute;
        right: 8px;
        bottom: 8px;
        font-size: 12px;
        line-height: 12px;
        color: #999;
      }
      .diagnose-info-item{
        margin-bottom: 32px;
        .info-content{
          margin-top: 12px;
          position: relative;
          .patient-info{
            font-size: 18px;
            line-height: 20px;
            color: @black;
            font-weight: bold;
          }
        }
      }
      .prescription-box{
        .prescription-type{
          font-size: 16px;
          color: #666;
          line-height: 16px;
          margin-bottom: 24px;
          font-weight: bold;
        }
        .prescription-header{
          display: flex;
          justify-content: space-between;
          align-items: center;
          h4{
            font-size: 18px;
            line-height: 18px;
            color: @black;
            font-weight: bold;
          }
          .new-prescription{
            display: flex;
            justify-content: flex-end;
            align-items: center;
            font-size: 14px;
            line-height: 14px;
            color: #999;
            svg{
              font-size: 12px;
              color: #999;
              margin-right: 4px;
            }
            &.enable{
              color: @xile;
              svg{
                color: @xile;
              }
            }
          }
          .edit-prescription{
            display: flex;
            justify-content: flex-end;
            align-items: center;
            font-size: 14px;
            line-height: 14px;
            color: #666;
            svg{
              font-size: 14px;
              color: #CCC;
            }
          }
        }
        .prescription-content{
          width: 100%;
          padding: 8px 0 20px;
          min-height: 33px;
          font-size: 14px;
          line-height: 28px;
          color: @black;
          font-weight: bold;
          .herb-item{
            font-weight: normal;
            padding: 25px 0 15px;
            border-bottom: 1px solid #F3F3F3;
            &:last-child{
              padding-bottom: 0;
              border-bottom: 0;
            }
            &:first-child{
              padding-top: 13px;
            }
            .herb-info{
              display: flex;
              justify-content: space-between;
              align-items: flex-end;
              font-weight: bold;
              margin-bottom: 8px;
              .herb-name{
                font-size: 15px;
                line-height: 21px;
                color: @black;
                max-width: 85%;
              }
              .herb-num{
                font-size: 15px;
                line-height: 21px;
                color: #666;
              }
            }
            .herb-tip{
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              font-size: 14px;
              line-height: 20px;
              color: #666;
              margin-bottom: 4px;
              span{
                flex-shrink: 0;
                margin-right: 4px;
              }
            }
            .herb-control{
              margin-top: 16px;
              display: flex;
              justify-content: flex-end;
              align-items: center;
              button{
                @button-base();
                @button-border();
                height: 32px;
                font-weight: normal;
                padding: 0 12px;
                margin-left: 12px;
                border-color: #E7EDF3;
                color: #666;
                border-radius: 3px;
                font-size: 14px;
                &.edit-herb{
                  color: @xile;
                }
              }
            }
          }
        }
      }
      .prescription-control{
        padding: 20px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        border-top: 1px solid #F3F3F3;
        .prescription-button{
          @button-base();
          @button-border();
          flex: 1;
          height: 36px;
          &:first-child{
            margin-right: 15px;
          }
          &:disabled{
            border-color: #CCC;
            color: #CCC;
          }
        }
      }
      .dosage-item{
        margin-bottom: 32px;
        .dosage-content{
          margin-top: 12px;
          .dosage-control-item{
            margin-top: 28px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .dosage-type{
              width: 64px;
              font-size: 16px;
              line-height: 16px;
              color: @black;
            }
          }
          .dosage-textarea{
            position: relative;
          }
        }
        .puick-attention{
          padding-top: 16px;
          h4{
            font-size: 13px;
            color: #666;
            font-weight: normal;
          }
          .attention-list{
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex-wrap: wrap;
            .attention-item{
              height: 30px;
              line-height: 30px;
              margin: 16px 16px 0 0;
              background: #FAFAFA;
              font-size: 14px;
              padding: 0 10px;
              color: #999;
              border-radius: 4px;
            }
          }
        }
      }
      .over-dose-box{
        .excess-list{
          font-size: 15px;
          line-height: 21px;
          color: @error;
          .excess-item{
            position: relative;
            padding-left: 10px;
            font-weight: bold;
            &::after{
              content: '';
              position: absolute;
              left: 2px;
              top: 10px;
              width: 3px;
              height: 3px;
              border-radius: 50%;
              background: @error;
            }
          }
        }
        .over-tips{
          font-weight: bold;
          font-size: 15px;
          line-height: 21px;
          color: #666;
          margin-top: 8px;
        }
        .sign-box{
          margin-top: 16px;
          margin-bottom: 23px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .type{
            font-size: 14px;
            line-height: 14px;
            color: #666;
            font-weight: bold;
          }
          .signature{
            position: relative;
            padding: 4px 4px 1px 4px;
            border: 1px solid #CA1F24;
            color: #CA1F24;
            text-align: center;
            font-weight: bold;
            font-size: 12px;
            line-height: 12px;
            border-radius: 2px;
            p{
              margin-top: 3px;
            }
            &::after{
              content: '';
              position: absolute;
              top: 17px;
              left: 50%;
              transform: translateX(-50%);
              width: calc(100% - 8px);
              height: 1px;
              background: #CA1F24;
            }
          }
        }
      }
      .price-item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 8px;
        margin-bottom: 24px;
        .price-type{
          font-size: 15px;
          line-height: 20px;
          color: @black;
          font-weight: bold;
          &.float-price{
            color: #666;
          }
          p{
            font-size: 14px;
            line-height: 20px;
            color: #666;
          }
          span{
            color: @error;
          }
        }
        .normal-price{
          font-size: 16px;
          line-height: 16px;
          font-weight: bold;
          color: @black;
          &.grey{
            color: #999;
          }
        }
      }
      .total-price{
        height: 80px;
        border-top: 1px solid #EEE;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .total{
          font-size: 20px;
          line-height: 20px;
          color: @black;
          font-weight: bold;
        }
        .price{
          position: relative;
          font-size: 24px;
          font-weight: bold;
          color: @xile;
          span{
            font-size: 18px;
          }
          &.grey{
            color: #999;
          }
        }
      }
    }
    .diagnose-bottom-control{
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 12px 0;
      .botton-button{
        @button-base();
        height: 40px;
        &.send{
          flex: 1;
        }
      }
    }
    .dialog-content{
      padding: 40px 0 32px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .text{
        font-size: 16px;
        line-height: 16px;
        color: @black;
        font-weight: bold;
        span{
          margin-left: 4px;
          color: @error;
        }
      }
      .control{
        margin-top: 36px;
        display: flex;
        justify-content: center;
        align-items: center;
        button{
          @button-base();
          height: 36px;
          font-size: 14px;
          width: 136px;
          &.cancel{
            background: #FFF;
            border: 1px solid #999;
            color: #999;
            margin-right: 15px;
          }
          &.confirm{}
        }
      }
    }
    // 模板列表弹窗
    .script-wrapper{
      height: calc(100%);
    }
    .prescription-list{
      height: 100%;
      background: #FAFAFA;
      overflow-y: auto;
      -webkit-overflow-scroll: touch;
      padding: 0 16px 16px;
      .prescription-item{
        margin-top: 12px;
        width: 100%;
        border-radius: 6px;
        overflow-y: hidden;
        box-shadow: 0px 2px 10px 0px rgba(51,51,51,0.08);
        border: 1px solid transparent;
        background: #FFF;
        &.selected{
          border-color: @xile;
        }
        .item-head{
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 48px;
          border-bottom: 1px solid #F3F3F3;
          padding: 0 16px;
          background: #FAFAFA;
          .item-title{
            position: relative;
            padding-left: 19px;
            font-size: 16px;
            line-height: 18px;
            font-weight: bold;
            color: @black;
            &.template{
              max-width: 100%;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow-x: hidden;
            }
            &::after{
              content: '';
              position: absolute;
              left: 0;
              top: 0;
              width: 4px;
              height: 16px;
              background: @xile;
              border-radius: 2px;
            }
          }
          .sub-title{
            max-width: 170px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 14px;
            color: @black;
          }
        }
        .prescription-card-content{
          padding: 20px;
          font-size: 14px;
          line-height: 24px;
          color: #666;
          .history-herb-item{
            margin-top: 20px;
            &:first-child{
              margin-top: 0;
            }
            .herb-info{
              display: flex;
              justify-content: space-between;
              align-items: flex-end;
              font-weight: bold;
              margin-bottom: 8px;
              .herb-name{
                font-size: 15px;
                line-height: 21px;
                color: @black;
                max-width: 85%;
              }
              .herb-num{
                font-size: 15px;
                line-height: 21px;
                color: #666;
              }
            }
            .herb-tip{
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              font-size: 14px;
              line-height: 20px;
              color: #666;
              margin-bottom: 4px;
              span{
                flex-shrink: 0;
                margin-right: 4px;
              }
            }
          }
        }
      }
    }
  }
</style>

<script type="text/javascript">
  import xDialog from '@/components/Common/dialog'
  export default {
    data() {
      return {
        // 处方剂型
        formulationType: parseInt(this.$route.query.type),
        // 患者信息
        patientInfo: {},
        // 主诉
        condition: '',
        // 诊断
        diagnoseText: '',
        // 药方
        herbList: [],
        // 超量药
        excessHerbs: [],
        // 注意事项
        attentionText: '',
        attentionTimeData: ['饭前一小时服', '饭后一小时服', '空腹服', '晨起服'],
        attentionTabooData: ['无', '忌辛辣', '忌油腻', '忌生冷', '忌烟酒', '忌发物', '忌荤腥', '忌酸涩', '忌刺激性食物', '忌光敏性食物', '忌难消化食物', '备孕禁服', '怀孕禁服', '经期停服', '感冒停服'],
        sendScriptShow: false,
        // 历史处方选择
        scriptPickShow: false,
        scriptList: [],
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      },
      // 药品总价
      totalPrice() {
        let totalPrice = 0;
        this.herbList.forEach(item => {
          totalPrice += parseFloat(item.totalPrice)
        })
        return totalPrice;
      },
      // 混合需要保存到store中的数据
      mixedData() {
        return {
          // 主诉
          condition: this.condition,
          // 诊断
          diagnoseText: this.diagnoseText,
          // 药方
          herbList: this.herbList,
          // 注意事项
          attentionText: this.attentionText,
        }
      }
    },
    components: {
      xDialog
    },
    created() {
      // 获取患者基本信息以及处方基本信息
      this.$root.post('/getInfo', {
        doc_id:this.userInfo.user_id,
        pat_id: this.$route.query.pat_id
      }).then(data => {
        console.log(data);
        this.patientInfo = data || {};
        // 若上个页面是处方编辑页面则需要回显之前填写的数据
        if(this.$store.state.prescriptionData) {
          let callBackData = this.$store.state.prescriptionData;
          console.log(callBackData)
          for(let item in callBackData) {
            this[item] = callBackData[item]
          }
          if(callBackData.herbList) {
            this.herbList = callBackData.herbList;
            this.updateExcess();
          }
          // 清空store中储存的临时数据
          this.$store.commit('clearPrescriptionData')
        }
      })
    },
    methods: {
      // 更新超量药数据
      updateExcess() {
        this.excessHerbs = [];
        this.herbList.forEach(item => {
          if(item.isExcess == true || item.isUnitExcess == true) {
            this.excessHerbs.push({
              name: this.formulationType == 3 ? item.name : item.common_name,
              isExcess: item.isExcess,
              isUnitExcess: item.isUnitExcess,
              maxDosage: item.max_dosage
            });
          }
        })
      },
      // 添加药品
      addHerb() {
        // 单个处方药品不能大于5种
        if(this.herbList.length >= 5) {
          this.$notify('同一处方至多开5种药');
          return;
        }
        // 将当前填写的数据信息存入store，在编辑处方药材完成后需回显此数据
        this.$store.commit('setPrescriptionData', this.mixedData);
        this.$router.push({path: '/doctor/diagnoseWest/herbEdit', query: {script_type: this.formulationType, edit_type: 'new'}});
      },
      // 删除药品
      delHerb(item) {
        this.herbList.splice(this.herbList.indexOf(item), 1);
        this.updateExcess();
      },
      editHerb(item) {
        this.$store.commit('setPrescriptionData', this.mixedData);
        this.$store.commit('setHerbsData', item);
        this.$router.push({path: '/doctor/diagnoseWest/herbEdit', query: {script_type: this.formulationType, edit_type: 'edit'}});
      },
      // 快速选择注意事项
      puickFillAttention(item) {
        // 字数即将大于最大值时取消操作
        let text = this.attentionText + `，${item}`;
        if(text.length >= 100) return;
        if(this.attentionText) {
          this.attentionText += `，${item}`;
        }else {
          this.attentionText = item;
        }
      },
      // 获取历史处方
      getHistory() {
        this.$toast.loading({
          duration: 0,
          forbidClick: true,
          loadingType: 'spinner',
          message: '加载中'
        })
        this.$root.post('/getPreList', {
          pat_id: this.$route.query.pat_id,
          doc_id: this.userInfo.user_id,
          type: this.formulationType
        }).then(data => {
          console.log(data);
          this.$toast.clear();
          this.scriptList = data || [];
          this.scriptPickShow = true;
        })
      },
      isListedHerb(herb) {
        let index = this.herbList.findIndex(item => {
          return item.id == herb.id;
        })
        if(index != -1) {
          return true;
        }else {
          return false;
        }
      },
      // 选择历史处方
      chooseScript(script) {
        if(script.content.length > 0) {
          if(script.content.length + this.herbList.length > 5) {
            this.$notify('同一处方至多开5种药');
            return;
          }
          this.$toast.loading({
            duration: 0,
            forbidClick: true,
            loadingType: 'spinner',
            message: '载入处方中'
          })
          this.$root.post('/getPrePrice', {
            content: script.content,
            company_name: this.formulationType,
          }).then(data => {
            console.log(data);
            this.$toast.clear();
            data.forEach(herb => {
              if(!this.isListedHerb(herb)) {
                // 将超量药数据类型转换为Boolean
                herb.isExcess = JSON.parse(herb.isExcess);
                herb.isUnitExcess = JSON.parse(herb.isUnitExcess);
                this.herbList.push(herb);
              }
            })
            this.updateExcess();
            this.scriptPickShow = false;
          })
        }
      },
      sendScriptTip() {
        if(!this.condition) {
          this.$notify('请填写主诉');return;
        }
        if(!this.diagnoseText) {
          this.$notify('请填写诊断');return;
        }
        if(this.herbList.length <= 0) {
          this.$notify('请先添加药品');return;
        }
        this.sendScriptShow = true;
      },
      sendScript() {
        let excessData = [];
        let unitExcessData = [];
        this.excessHerbs.forEach(item => {
          if(item.isExcess) {
            excessData.push(item.name);
          }
          if(item.isUnitExcess) {
            unitExcessData.push(item.name);
          }
        })
        const postData = {
          pat_id: this.$route.query.pat_id,
          doc_id: this.userInfo.user_id,
          self_reported: this.condition,
          diagnose: this.diagnoseText,
          type: this.formulationType,
          content: this.herbList,
          advice: this.attentionText,
          excess: excessData.join(','),
          unit_excess: unitExcessData.join(','),
          ori_price: this.totalPrice,
          price: this.totalPrice,
        }
        console.log(postData);
        this.sendScriptShow = false;
        this.$toast.loading({
          duration: 0,
          forbidClick: true,
          loadingType: 'spinner',
          message: '提交中'
        });
        this.$root.post('/addPrescription', postData).then(data => {
          this.$toast.clear();
          if(data.status == 1) {
            if(data.is_audit == 1) {
              // 无需审核的话直接发送处方卡片
              let _this = this;
              // 发送自定义的处方卡片
              let conversationType = RongIMLib.ConversationType.PRIVATE;
              let targetId = this.$route.query.pat_id.toString();
              let msg = new RongIMClient.RegisterMessage.PreMessage({
                username: data.info.username,
                type: data.info.type,
                diagnose: data.info.diagnose,
                create_time: data.info.create_time,
                birthday: data.info.birthday,
                gender: data.info.gender,
                id: data.info.id,
              })
              RongIMClient.getInstance().sendMessage(conversationType, targetId, msg, {
                onSuccess: function (message) {
                  _this.$notify({
                    background: '#00848A',
                    message: '提交成功，处方正在审核中'
                  });
                  // 为了正确获取聊天页的历史消息，需要做一个1秒的延迟
                  setTimeout(() => {
                    RongIMClient.getInstance().getHistoryMessages(conversationType, targetId, 0, 2, {
                      onSuccess(list) {
                        console.log('发完处方1000毫秒后获取历史消息', list);
                      },
                      onError(error) {
                        console.log(error)
                      }
                    })
                    _this.$router.go(-1);
                  }, 1000)
                },
                onError: function (errorCode) {
                  console.log('发送自定义消息失败', errorCode);
                }
              })
            }else if(data.is_audit == 2) {
              // 需要审核的话直接显示成功文案
              this.$notify({
                background: '#00848A',
                message: '提交成功，处方正在审核中'
              });
              setTimeout(() => {
                this.$router.go(-1);
              }, 1000);
            }
          }else {
            this.$notify(data.msg);
          }
        })
      }
    },
    filters: {
      formulationTypeFilter(type) {
        switch(type) {
          case 3: return '器械耗材';break;
          case 5: return '西药';break;
          case 6: return '中成药';break;
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Doctor/Diagnose/diagnoseWest.vue